import React from 'react'
import styled from 'styled-components'

 const EmptyDivElement = styled.div`
  width: auto;
`

const DownArrowIcon = ({ onClick }) => {
  return (
    <EmptyDivElement onClick={onClick}>
      <svg
        width="15"
        height="15"
        viewBox="0 -0.5 17 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className="si-glyph si-glyph-arrow-thin-down"
      >
        <title>1161</title>
        <defs></defs>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M9.031,15.97 L2.339,9.665 C1.88,9.206 2.043,8.505 2.245,8.306 C2.648,7.904 3.243,7.964 3.647,8.367 L8.085,12.263 L8.086,0.948 C8.087,0.436 8.512,0.022 9.038,0.021 C9.563,0.02 9.989,0.436 9.988,0.948 L10.001,12.16 L14.272,8.306 C14.676,7.904 15.331,7.904 15.733,8.306 C16.138,8.706 16.037,9.256 15.632,9.658 L9.031,15.97 L9.031,15.97 Z"
            fill="rgb(204, 207, 214)"
            className="si-glyph-fill"
          ></path>
        </g>
      </svg>
    </EmptyDivElement>
  )
}

export default DownArrowIcon
